/**
 * ------------------------------------------------------------------------
 * FORM FILE JS
 * ------------------------------------------------------------------------
 */

function uploadFile(target) {
    var file = document.getElementsByClassName("file__label");
	file[0].innerHTML = target.files[0].name;
}
